import React from "react";
import { Button } from "semantic-ui-react";

const ExpandButton = (props) => {
  const { active, onClick, content } = props;
  return (
    <Button
      floated={props.floated ?? "right"}
      fluid={props.fluid || false}
      size={props.size || "small"}
      content={content}
      basic={active}
      compact={typeof props.compact !== "undefined" ? props.compact : true}
      icon={props.icon || "expand"}
      color="grey"
      onClick={onClick}
      disabled={props.disabled || false}
    />
  );
};

export default ExpandButton;
